<script setup lang="ts">
import { Menu, X } from '@lucide/vue'
import { ref, watch } from 'vue'
import { useRoute } from 'vue-router'
import { useI18n } from 'vue-i18n'
import LogoMark from '@/components/atoms/LogoMark.vue'

const open = ref(false)
const route = useRoute()
const { t } = useI18n()
watch(() => route.fullPath, () => { open.value = false })

const left = [{ to: '/games', key: 'nav.games' }, { to: '/raffles', key: 'nav.raffles' }]
const right = [{ to: '/claim-win', key: 'nav.claim' }, { to: '/contact', key: 'nav.contact' }]
</script>

<template>
  <header class="fixed inset-x-0 top-0 z-50 border-b border-white/10 bg-ink/80 backdrop-blur-xl">
    <nav class="page-shell grid h-[76px] grid-cols-[1fr_auto_1fr] items-center" :aria-label="t('brand.name')">
      <div class="hidden items-center gap-8 lg:flex">
        <RouterLink v-for="item in left" :key="item.to" :to="item.to" class="focus-ring text-xs font-bold uppercase tracking-[.16em] text-zinc-300 transition hover:text-white" active-class="!text-signal">{{ t(item.key) }}</RouterLink>
      </div>
      <RouterLink to="/" class="focus-ring relative justify-self-center" :aria-label="t('brand.name')">
        <LogoMark compact />
        <span class="absolute -bottom-[19px] left-1/2 h-[3px] w-9 -translate-x-1/2 bg-signal" />
      </RouterLink>
      <div class="hidden items-center justify-end gap-8 lg:flex">
        <RouterLink v-for="item in right" :key="item.to" :to="item.to" class="focus-ring text-xs font-bold uppercase tracking-[.16em] text-zinc-300 transition hover:text-white" active-class="!text-signal">{{ t(item.key) }}</RouterLink>
      </div>
      <button class="focus-ring col-start-3 justify-self-end rounded-lg p-2 lg:hidden" :aria-expanded="open" :aria-label="open ? t('nav.close') : t('nav.menu')" @click="open = !open">
        <X v-if="open" /> <Menu v-else />
      </button>
    </nav>
    <Transition enter-active-class="transition duration-200" enter-from-class="-translate-y-3 opacity-0" leave-active-class="transition duration-150" leave-to-class="-translate-y-3 opacity-0">
      <div v-if="open" class="border-t border-line bg-ink px-5 py-6 lg:hidden">
        <div class="grid gap-2">
          <RouterLink v-for="item in [...left, ...right]" :key="item.to" :to="item.to" class="focus-ring rounded-lg px-4 py-4 font-display text-3xl uppercase hover:bg-white/5" active-class="text-signal">{{ t(item.key) }}</RouterLink>
        </div>
      </div>
    </Transition>
  </header>
</template>
